module.exports = __webpack_public_path__ + "img/Icon_Top_Level.a335e639.png";